import axios from "axios";
import store from "./store";
import { logoutUser } from "./actions/authActions";

const axiosInstance = axios.create({
  //baseURL: "http://127.0.0.1:8000/api/",
  //baseURL: "https://www.staging.thrive-booking.com/backend/public/api",
  baseURL: "https://www.meetocto.com/backend/public/api"
});


// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - logout user
      store.dispatch(logoutUser());
      window.location.href = "/admin/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;